import { render, staticRenderFns } from "./orderInfoWindow.vue?vue&type=template&id=462b6b77&scoped=true"
import script from "./orderInfoWindow.vue?vue&type=script&lang=js"
export * from "./orderInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./orderInfoWindow.vue?vue&type=style&index=0&id=462b6b77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b6b77",
  null
  
)

export default component.exports